import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const TransferTypeSchema = BigdesDefinitionSchema.extend({});
export const CreateTransferTypeSchema = TransferTypeSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateTransferTypeSchema = TransferTypeSchema.partial();
